import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { CarteirasPanel, type CarteirasPanelProps } from './CarteirasPanel'

interface CarteirasDialogProps extends CarteirasPanelProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

/** Carteiras na tela de tarefas (a mesma gestão de Configurações › Carteiras). */
export function CarteirasDialog({ open, onOpenChange, ...panel }: CarteirasDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Carteiras</DialogTitle>
          <DialogDescription>Grupos de pessoas para filtrar as tarefas.</DialogDescription>
        </DialogHeader>
        <CarteirasPanel {...panel} />
      </DialogContent>
    </Dialog>
  )
}
